import api from './'

export default {

    /**
     * Get list of group rules
     * @param params
     */
    get(params) {
        return api
            .get(`/groupRules`, { params: params })
            .then(response => {
                return response.data
            })
    },

    /**
     * Show a group rule
     * @param groupRule
     * @param params
     */
    show(groupRule, params) {
        return api
            .get(`/groupRules/${groupRule}`, { params: params })
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete a group rule
     * @param groupRule
     */
    delete(groupRule) {
        return api
            .delete(`/groupRules/${groupRule}`)
            .then(response => {
                return response.data
            })
    }

}
